import { AnyAction } from "redux";
import { SET_EDIT_ROLE_PAGINATED_REPORTS_LOADED } from "../actions/loadingEditRolePaginatedReports";

export const loadingEditRolePaginatedReports = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_EDIT_ROLE_PAGINATED_REPORTS_LOADED:
      return action.editRolePaginatedReportsLoaded;
    default:
      return state;
  }
};

export default loadingEditRolePaginatedReports;
